export default {
  type: "object",
  category: "app",
  target: { type: "app", key: "app" },
  "feature-flags": ["!APP_NEW_CODE_CHEST"],
  commands: {
    locked: true,
    code: [
      {
        "hard-lock": true,
        type: "command",
        fn: "time",
        args: {
          arguments: [
            {
              code: {
                "hard-lock": true,
                type: "string",
                value: "All",
                editable: false,
              },
            },
          ],
        },
      },
    ],
  },
};
